import { EnumSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { BankAccountScheme } from './bank-account.scheme.enum.entity';

export const BaseBankAccountPayloadSchema = z.object({
    type: EnumSchema(BankAccountScheme),
});

export class BankAccountPayload {
    type: BankAccountScheme;
}
